// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_nw-5";
export var filledCircle = "_nw-4";
export var historyEntry = "_nw-3";
export var messageSideLeft = "_nw-1";
export var messageSideRight = "_nw-2";
export var orderTrackingCarouselWrapper = "_nw-6";
export var orderTrackingInfoContainer = "_nw-0";